import { render, staticRenderFns } from "./AttendencePlaceForm.vue?vue&type=template&id=1095600b&scoped=true"
import script from "./AttendencePlaceForm.vue?vue&type=script&lang=js"
export * from "./AttendencePlaceForm.vue?vue&type=script&lang=js"
import style0 from "./AttendencePlaceForm.vue?vue&type=style&index=0&id=1095600b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1095600b",
  null
  
)

export default component.exports